import React, { useState, useEffect } from 'react'
import { BaseForm } from './BaseForm/BaseForm.jsx'
import { TextArea, InputGroup } from './formInputs/index.jsx'
import './WholesalerContactForm.css'
import '../wholesaler/wholesaler.css'
import {
  isInstitutional,
  getAuthManagerInstance,
} from '../../../global/authentication/authentication-manager.js'
import { getWholesalerFromcookies, findAdvisor } from '../wholesaler/utils.js'
import { validate } from './formInputs/inputValidation'
import { postJsonRawResponse } from '../../../global/data/service'

const strings = {
  formId: 'AdvisorContactForm',
  message: 'Message',
  url: '/adv.svc/secure/mailSalesContact',
  headline: 'Get in touch with your consultant',
  subtitle:
    "All fields are required. Please don't include any identifiable information, such as account numbers, in your message.",
}

const defaultErrors = {
  [strings.message]: null,
}

export function WholesalerContactForm() {
  const [userInput, setUserInput] = useState(defaultErrors)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [errors, setErrors] = useState(defaultErrors)
  const [wholesaler, setWholesaler] = useState(undefined)

  useEffect(() => {
    if (isInstitutional()) {
      const wholesalerData = getWholesalerFromcookies()
      setWholesaler(wholesalerData)
    } else {
      getAuthManagerInstance()
        .getProfileServiceBehaviorSubject()
        .subscribe((profile) => {
          const searchArray =
            window.location.search && window.location.search.split('=')
          const emailId = searchArray.length > 1 && searchArray[1]
          const wholesalerData = findAdvisor(
            profile?.salesContactByChannel,
            emailId
          )
          setWholesaler(wholesalerData)
        })
    }
  })

  const createEmailPayload = (formData) => {
    return {
      subject: 'Wholesaler Contact Form',
      message: formData[strings.message],
      phoneNbr: wholesaler.phoneNbr,
      salesContactId: wholesaler.emailId,
    }
  }

  const inputChangeHandler = (e, input) => {
    setUserInput({
      ...userInput,
      [input]: e.target.value,
    })
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    event.stopPropagation()
    setErrors(defaultErrors)
    const e = {}
    const validationErrors = validate(userInput, {
      [strings.message]: (value) => {
        return value.length < 4
      },
    })
    validationErrors.forEach((el) => {
      e[el] = true
    })

    if (validationErrors.length) {
      setErrors(e)
    } else {
      const response = await postJsonRawResponse(
        strings.url,
        createEmailPayload(userInput)
      )
      setIsSuccess(response.ok)
      setIsSubmitted(true)
    }
  }

  const headline = (
    <div className="u-flex u-flexJustifyStart u-paddingVert10gu u-bgColorBrand">
      <h1 className="u-sizeConstrained u-textColorWhite">{strings.headline}</h1>
    </div>
  )

  const wholeSalerInfo = () => {
    if (!wholesaler) {
      return false
    }
    const {
      preferredFirstNm,
      preferredLastNm,
      designationCd,
      titleCd,
      photoURL,
      phoneNbr,
    } = wholesaler
    return (
      <div className="u-size1of3 u-sm-sizeFull u-paddingRight5gu u-sm-paddingRight0">
        <div className="u-marginTop3gu">
          <p className=" u-marginBottom1gu">Recipient</p>
          <div className="u-flex Wholesaler">
            <div className="photo">
              <img
                className=""
                src={
                  photoURL
                    ? photoURL
                    : '/binaries/content/gallery/cti-blog/imported/cti-blank-profile.jpg/cti-blank-profile.jpg'
                }
                alt={preferredFirstNm}
                data-qa-automation="wholesaler-image"
              />
            </div>
            <div className="u-marginLeft3gu">
              <h3 className={`u-textSecondary u-textColorBrandDarker title`}>
                {preferredFirstNm} {preferredLastNm}
                {designationCd && (
                  <React.Fragment>
                    , <span className="u-textColorWhite">{designationCd}</span>
                  </React.Fragment>
                )}
              </h3>
              <p className="u-marginBottom2gu text">{titleCd}</p>
              <a href={`tel:${phoneNbr}`} className="Link">
                {phoneNbr}
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <BaseForm
      isSubmitted={isSubmitted}
      subtitle={strings.subtitle}
      headline={headline}
      isSuccess={isSuccess}
    >
      <form
        onSubmit={(e) => handleSubmit(e)}
        id={strings.formId}
        className="u-marginTop5gu"
      >
        <div className="u-flex u-sm-flexCol">
          {wholeSalerInfo(wholesaler)}
          <div className="u-size2of3 u-sm-sizeFull u-paddingRight5gu u-sm-paddingRight0">
            <div className="u-marginTop3gu">
              <InputGroup
                name={strings.message}
                error={errors[strings.message]}
                onChange={(e) => {
                  inputChangeHandler(e, strings.message)
                }}
                render={(props) => {
                  return <TextArea {...props} />
                }}
              />
            </div>
          </div>
        </div>
        <div className="u-marginTop5gu">
          <button className="Button Button--primary" type="submit">
            Submit
          </button>
        </div>
      </form>
    </BaseForm>
  )
}
